<template>
  <content-subpage
    :visible="visible"
    :titles="titles"
    :show-content-title="false"
    class="tag-list-content-subpage"
    @content-subpage-hidden="actionHidden"
  >
    <template #title></template>
    <template #main-content>
      <dl class="tag-list">
        <dt class="title">
          {{ params.listTitle }} <span class="number">{{ params.list.length }}</span>
        </dt>
        <dd v-for="(tag, index) in params.list" :key="index" class="tag">
          {{ tag }}
        </dd>
      </dl>
    </template>
  </content-subpage>
</template>

<script setup lang="ts">
import { useContentSubpage } from "@plugins/content-subpage/composables/content-subpage.js";
import { onMounted } from "vue";

// Props
interface Props {
  params?: Record<string, unknown>;
}

const { params = null } = defineProps<Props>();

const { visible, titles, actionHidden, defaultExpose } = useContentSubpage(params);

onMounted(() => {
  titles.value.push(params.title);
});

defineExpose(defaultExpose);
</script>

<style lang="scss">
@import "@styles/abstracts/functions";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.tag-list-content-subpage {
  .tag-list {
    > .title {
      @include carbon--type-style("productive-heading-01", true);
      display: flex;
      margin-bottom: $spacing-03;
    }

    .number {
      padding: $spacing-01 $spacing-03;
      margin-left: auto;
      border-radius: 5px;
      background-color: tint($support-04, 90%);
      color: $support-04;
    }
  }

  .tag {
    padding: $spacing-05 0;
    border-top: 1px solid $ui-03;
  }
}
</style>
